var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import { FTLLabel } from "../FTLLabel";
import { FTLTypography } from "../FTLTypography";
import { FTLDots } from "../FTLDots";
export const FTLFakeTextField = (_a) => {
    var { loaded = true, startIcon, endIcon, label = "", required = false, value = "", onClick } = _a, otherProps = __rest(_a, ["loaded", "startIcon", "endIcon", "label", "required", "value", "onClick"]);
    const classes = useStyles({ onClick, loaded });
    return (React.createElement("div", null,
        label && React.createElement(FTLLabel, { label: label, required: required, mb: 1 }),
        React.createElement(Box, Object.assign({ display: "flex", alignItems: "center", justifyContent: "space-between", className: classes.root, onClick: (e) => onClick && loaded && onClick(e) }, otherProps),
            React.createElement(Box, { display: "flex", alignItems: "center" },
                startIcon,
                React.createElement(Box, { ml: startIcon ? 2 : 0, mr: endIcon ? 2 : 0 }, loaded ? (React.createElement(FTLTypography, { variant: "listItemText" }, value ? value : "—")) : (React.createElement(FTLDots, { color: "dark" })))),
            endIcon)));
};
const useStyles = makeStyles((theme) => ({
    root: ({ onClick, loaded, }) => ({
        cursor: onClick ? "pointer" : "default",
        borderRadius: 4,
        padding: "4px 8px",
        margin: "0 -8px",
        transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1)",
        "& > svg": {
            visibility: "hidden",
        },
        "&:hover": {
            backgroundColor: onClick && loaded ? theme.palette.textField.hover : "",
            "& > svg": {
                visibility: onClick && loaded ? "visible" : "hidden",
            },
        },
    }),
}));
//# sourceMappingURL=index.js.map